import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const acronis = defineConnector({
  identifier: "acronis",
  name: "Acronis",
  tagLine: "Cyber protection and backup",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.acronis\\.com/api/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Acronis Developer Portal](https://developer.acronis.com/) to create an API client and obtain your client ID and secret.",
        },
      ],
    },
    {
      title: "Enter your data center URL",
      items: [
        {
          kind: "url",
          label: "Data center URL",
          placeholder: "https://cloud.acronis.com",
          required: true,
          target: { kind: "configuration", field: "dataCenterUrl" },
          helperText:
            "Your Acronis data center URL (e.g., https://eu2-cloud.acronis.com).",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "Tenant ID",
          required: true,
          target: { kind: "configuration", field: "tenantId" },
          helperText: "The tenant your API client is scoped to.",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ dataCenterUrl }) => `${dataCenterUrl}/api/2/idp/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ dataCenterUrl }) => `${dataCenterUrl}/api/2/tenants`,
  },
});
